<template>
  <div class="detail-content lkt-convenant">
    <div class="exam_begins_box" ref="middle_page">
        <p class="examination_notes" style></p>
        <div class="button_box" style="margin-top:10px;border-top:1px solid #bbbbbb"></div>
        <div style="margin-top:20px" class="color-text">
          <pre v-html="this.covenantInfo.contentList[currentPage -1]" @click="checkClick" @mouseover="mouseOver" @mouseout="mouseout"></pre>
        </div>
        <div class="button_box" style="margin-top:10px;border-top:1px solid #bbbbbb"></div>
        <div class="button_box" style="margin-top:20px;">
          <el-checkbox v-if="covenantInfo.flag == 0 && covenantInfo.checkBoxList[currentPage -1] == '1'" v-model="covenantInfo.agreeFlag[currentPage -1]">
            <span style="color:#00BFFF;font-size:16px">{{covenantInfo.checkContentList[currentPage -1]}}</span>
          </el-checkbox>
          
          <div v-if="covenantInfo.flag == 1 && covenantInfo.checkBoxList[currentPage -1] == '1'">
            <i class="el-icon-check" style="font-size:18px;color:#00FF00;font-weight:bold"></i>
            <span style="color:#00BFFF;font-size:16px">{{covenantInfo.checkContentList[currentPage -1]}}</span>
          </div>
        </div>
        <div class="button_box">
          <button
            v-if="covenantInfo.flag == 0"
            class="btn-01 btn-login bd-0"
            @click="handleHintBox"
          >{{$t('questionnaire.submit')}}</button>
          <button
            class="btn-01 btn-login btn-back bd-0"
            @click="goto_lesson"
          ><span>{{$t('common.returnButton')}}</span></button>
        </div>
        <div class="taskContent_page mg-task">
          <el-pagination
            class="task_el_pagination"
            :current-page="currentPage"
            background
            layout="pager"
            :pageSize="1"
            :total="covenantInfo.totalNum"
            hide-on-single-page="true"
            @current-change="current_change"
          ></el-pagination>
        </div>
      </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { Checkbox } from 'element-ui';
export default {
  name: "exam_begins",
  data() {
    return {
      value: true,
      agreeFlag: false,
      currentPage : 1,
      covenantInfo: {contentList:[""]},
      userId: null, //用户id
      courseId: null, //课程id
      checkItem:[],
      selectItem:[],
      textboxItem:[],
      itemList:[],
      templateType:null,
      categoryCourse: 0,
    };
  },
  beforeRouteLeave(to, form, next) {
    next()
  },
  mounted() {
    
    //获取设备屏幕的高度
    const h = document.body.clientHeight - 299;
    // this.$refs.middle_page.style.minHeight = h + "px";
    this.$autoLogin().then(
      () => {
        //接收参数
        this.courseId = this.$route.query.courseId;
        this.templateType = this.$route.query.templateType;
        //登录成功
        this.userId = window.sessionStorage.getItem("id");
        this.role = window.sessionStorage.getItem("role");
        /// check category course
        this.$api.post("/courseStudy/getCourseCategory", {
            courseId: this.courseId,
        })
        .then((response) => {
            this.categoryCourse = parseInt(response.data.courseCategoryCode);
        })
        .catch((err) => {});
        //查询用户是否作答过问卷调查题
        this.$api
          .post("/studyCourseQuestion/getScheduleCovenant", {
            id: this.courseId,
            templateType:this.templateType,
          })
          .then((response) => {
            if (response.data != null) {
              const that = this;
              that.covenantInfo = response.data;
              that.covenantInfo["checkContentList"] = [];
              let j = 0;
              
              for(var i =0 ;i<that.covenantInfo.contentList.length;i++){
                let checkObj = [];
                let selectObj = [];
                if(that.covenantInfo.checkBoxList[i].split(":")[0] === "1") {
                  that.covenantInfo.checkContentList[i] = that.covenantInfo.checkBoxList[i].split(":")[1];
                  that.covenantInfo.checkBoxList[i] = that.covenantInfo.checkBoxList[i].split(":")[0];
                } else {
                  that.covenantInfo.checkBoxList[i] = null;
                }
                
                that.covenantInfo.contentList[i] =
                "<p>" +
                that.covenantInfo.contentList[i]
                  .replace(/\n*$/g, "")
                  .replace(/\n/g, "</p><p>") +
                "</p>";
                that.covenantInfo.contentList[i] = that.covenantInfo.contentList[i].replace(
                  "Ⓓ",
                  that.covenantInfo.agreeDate
                );
                that.covenantInfo.contentList[i] = that.covenantInfo.contentList[i].replace(
                  "Ⓒ",
                  that.covenantInfo.companyName
                );
                that.covenantInfo.contentList[i] = that.covenantInfo.contentList[i].replace(
                  "Ⓝ",
                  that.covenantInfo.userName
                );
                let p = that.covenantInfo.contentList[i].match(/<p([\s\S]*?)\/p>/g);
                var element= $(that.covenantInfo.contentList[i]);
                var covenantHtml = "";
                var index = 0;
                that.itemList[i] = [];
                if(that.covenantInfo.flag == 0) {
                  for(var a =0 ;a<element.length ; a++){
                    if($(element.get(a)).prop('nodeName') === "P") {
                      var outerHtml = $(element.get(a)).prop("outerHTML");
                      // 多选
                      let checkBoxs = outerHtml.match(/Ⓜ([\s\S]*?)Ⓔ/g);
                      if(checkBoxs != null && checkBoxs != undefined){
                        for(var j= 0;j<checkBoxs.length;j++){
                          if(checkBoxs[j] != null && checkBoxs[j] != undefined){
                            var html = "";
                            var options = checkBoxs[j].match(/Ⓜ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            for(var k=1;k<options.length;k++){
                              html = html + "<br><input type='checkbox' name='checkItem' id='checkItem_" + index + "_" + k + "' value='" + options[k] + "'/>" + options[k];
                            }
                            
                            that.itemList[i].push({"id":"checkItem_" + index,"index":index,"type":"checkBox","label":options[0],"value":"","count":k});
                            index++;
                            outerHtml = outerHtml.replace(
                            checkBoxs[j],
                            html
                            );
                          }
                        }
                      }
                      // 单选
                      let redioButtons = outerHtml.match(/Ⓢ([\s\S]*?)Ⓔ/g);
                      if(redioButtons != null && redioButtons != undefined){
                        for(var j= 0;j<redioButtons.length;j++){
                          if(redioButtons[j] != null && redioButtons[j] != undefined){
                            var html = "";
                            var options = redioButtons[j].match(/Ⓢ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            for(var k=1;k<options.length;k++){
                              html = html + "<br><input type='radio' name='radioItem' id='radioItem_" + index + "_" + k + "' value='" + options[k] + "'/>" + options[k];
                            }
                            
                            that.itemList[i].push({"id":"radioItem_" + index,"index":index,"type":"radio","label":options[0],"value":"","count":k});
                            index++;
                            outerHtml = outerHtml.replace(
                            redioButtons[j],
                            html
                            );
                          }
                        }
                      }
                      // 下拉框
                      let selects = outerHtml.match(/▼([\s\S]*?)Ⓔ/g);
                      if(selects != null && selects != undefined){
                        for(var j= 0;j<selects.length;j++){
                          if(selects[j] != null && selects[j] != undefined){
                            var html = "";
                            var options = selects[j].match(/▼([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            html = html + "<select class='select' name='selectItem' id='selectItem_" + index + "'>";
                            for(var k=1;k<options.length;k++){
                              html = html +  "<option value='"+options[k]+"'>"+options[k]+"</option>";;
                            }
                            html = html + "</select>";
                            
                            that.itemList[i].push({"id":"selectItem_" + index,"index":index,"type":"select","label":options[0],"value":"","count":0});
                            index++;
                            outerHtml = outerHtml.replace(
                            selects[j],
                            html
                            );
                          }
                        }
                      }
                      // 文本框
                      let textBoxs = outerHtml.match(/Ⓣ([\s\S]*?)Ⓔ/g);
                      
                      if(textBoxs != null && textBoxs != undefined){
                        for(var j= 0;j<textBoxs.length;j++){
                          if(textBoxs[j] != null && textBoxs[j] != undefined){
                            var html = "";
                            var options = textBoxs[j].match(/Ⓣ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            if(options[1]!=null && options[1]!= undefined){
                              html = html + "<input type='text' name='textItem' style='width:" + options[1] + "px' id='textItem_" + index + "'/>";
                            }
                            
                            that.itemList[i].push({"id":"textItem_" + index,"index":index,"type":"textBox","label":options[0],"value":"","count":0});
                            index++;
                            outerHtml = outerHtml.replace(
                            textBoxs[j],
                            html
                            );
                          }
                        }
                      }
                      // 文本描述题
                      let textAreas = outerHtml.match(/Ⓐ([\s\S]*?)Ⓔ/g);
                      if(textAreas != null && textAreas != undefined){
                        for(var j= 0;j<textAreas.length;j++){
                          if(textAreas[j] != null && textAreas[j] != undefined){
                            var html = "";
                            var options = textAreas[j].match(/Ⓐ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            html = html + "<br><textarea  name='textAreaItem'";
                            if(options[1]!=null && options[1]!= undefined){
                              html = html + " rows='" + options[1] + "'";
                            }
                            if(options[2]!=null && options[2]!= undefined){
                              html = html + " cols='" + options[2] + "'";
                            }
                            html = html + " id='textAreaItem_" + index + "'></textarea>";
                            
                            that.itemList[i].push({"id":"textAreaItem_"+index,"index":index,"type":"textArea","label":options[0],"value":"","count":0});
                            index++;
                            outerHtml = outerHtml.replace(
                            textAreas[j],
                            html
                            );
                          }
                        }
                      }
                      // 等级题（星号）
                      let starts = outerHtml.match(/Ⓧ([\s\S]*?)Ⓔ/g);
                      if(starts != null && starts != undefined){
                        for(var j= 0;j<starts.length;j++){
                          if(starts[j] != null && starts[j] != undefined){
                            var html = "";
                            var options = starts[j].match(/Ⓧ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + "<br>" + options[0] + "　";
                            html = html + "<ul class='cleanfloat'><li name='star' style='list-style:none; float:left; font-size:15px; margin:5px;cursor:pointer;'  id='star_" + index + "_1'>★</li><li style='list-style:none; float:left; font-size:15px; margin:5px; cursor:pointer;'  name='star' id='star_" + index + "_2'>★</li><li style='list-style:none; float:left; font-size:15px; margin:5px; cursor:pointer;'  name='star' id='star_" + index + "_3'>★</li><li style='list-style:none; float:left; font-size:15px; margin:5px; cursor:pointer;'  name='star' id='star_" + index + "_4'>★</li><li style='list-style:none; float:left; font-size:15px; margin:5px;cursor:pointer;'  name='star' id='star_" + index + "_5'>★</li></ul><br>";
                            that.itemList[i].push({"id":"star_" + index,"index":index,"type":"star","label":options[0],"value":"","count":0});
                            index++;
                            outerHtml = outerHtml.replace(
                            starts[j],
                            html
                            );
                          }
                        }
                      }
                      covenantHtml = covenantHtml + outerHtml;
                    } 
                  }
                } else {
                  for(var a =0 ;a<element.length ; a++){
                    if($(element.get(a)).prop('nodeName') === "P") {
                      var outerHtml = $(element.get(a)).prop("outerHTML");
                      // 多选
                      let checkBoxs = outerHtml.match(/Ⓜ([\s\S]*?)Ⓔ/g);
                      if(checkBoxs != null && checkBoxs != undefined){
                        for(var j= 0;j<checkBoxs.length;j++){
                          if(checkBoxs[j] != null && checkBoxs[j] != undefined){
                            var html = "";
                            var options = checkBoxs[j].match(/Ⓜ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            var value;
                            for(var k=1;k<options.length;k++){
                              for(var l = 0;l<response.data.covenantAnswerList.length;l++){
                                if(response.data.covenantAnswerList[l].pageNum === i && response.data.covenantAnswerList[l].index === index){
                                  if(response.data.covenantAnswerList[l].value.indexOf(options[k]) != -1){
                                    html = html + "<br><input type='checkbox' checked='true' disabled name='checkItem' id='checkItem_" + index + "_" + k + "' value='" + options[k] + "'/>" + options[k];
                                  } else {
                                    html = html + "<br><input type='checkbox' disabled name='checkItem' id='checkItem_" + index + "_" + k + "' value='" + options[k] + "'/>" + options[k];
                                  }
                                  value = response.data.covenantAnswerList[l].value;
                                }
                              }
                            }
                            
                            that.itemList[i].push({"id":"checkItem_" + index,"index":index,"type":"checkBox","label":options[0],"value":value,"count":k});
                            index++;
                            outerHtml = outerHtml.replace(
                            checkBoxs[j],
                            html
                            );
                          }
                        }
                      }
                      // 单选
                      let redioButtons = outerHtml.match(/Ⓢ([\s\S]*?)Ⓔ/g);
                      if(redioButtons != null && redioButtons != undefined){
                        for(var j= 0;j<redioButtons.length;j++){
                          if(redioButtons[j] != null && redioButtons[j] != undefined){
                            var html = "";
                            var options = redioButtons[j].match(/Ⓢ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            var value;
                            for(var k=1;k<options.length;k++){
                              for(var l = 0;l<response.data.covenantAnswerList.length;l++){
                                if(response.data.covenantAnswerList[l].pageNum === i && response.data.covenantAnswerList[l].index === index){
                                  if(response.data.covenantAnswerList[l].value.indexOf(options[k]) != -1){
                                    html = html + "<br><input type='radio' name='radioItem' checked='true' disabled id='radioItem_" + index + "_" + k + "' value='" + options[k] + "'/>" + options[k];
                                  } else {
                                    html = html + "<br><input type='radio' name='radioItem'  disabled id='radioItem_" + index + "_" + k + "' value='" + options[k] + "'/>" + options[k];
                                  }
                                  value = response.data.covenantAnswerList[l].value;
                                }
                              }
                            }
                            
                            that.itemList[i].push({"id":"radioItem_" + index,"index":index,"type":"radio","label":options[0],"value":value,"count":k});
                            index++;
                            outerHtml = outerHtml.replace(
                            redioButtons[j],
                            html
                            );
                          }
                        }
                      }
                      // 下拉框
                      let selects = outerHtml.match(/▼([\s\S]*?)Ⓔ/g);
                      if(selects != null && selects != undefined){
                        for(var j= 0;j<selects.length;j++){
                          if(selects[j] != null && selects[j] != undefined){
                            var html = "";
                            var options = selects[j].match(/▼([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            html = html + "<select class='select' disabled name='selectItem' id='selectItem_" + index + "'>";
                            var value;
                            for(var k=1;k<options.length;k++){
                              for(var l = 0;l<response.data.covenantAnswerList.length;l++){
                                if(response.data.covenantAnswerList[l].pageNum === i && response.data.covenantAnswerList[l].index === index){
                                  if(response.data.covenantAnswerList[l].value.indexOf(options[k]) != -1){
                                    html = html +  "<option selected value='"+options[k]+"'>"+options[k]+"</option>";
                                  } else {
                                    html = html +  "<option value='"+options[k]+"'>"+options[k]+"</option>";
                                  }
                                  value = response.data.covenantAnswerList[l].value;
                                }
                              }
                            }
                            html = html + "</select>";
                            
                            that.itemList[i].push({"id":"selectItem_" + index,"index":index,"type":"select","label":options[0],"value":value,"count":0});
                            index++;
                            outerHtml = outerHtml.replace(
                            selects[j],
                            html
                            );
                          }
                        }
                      }
                      // 文本框
                      let textBoxs = outerHtml.match(/Ⓣ([\s\S]*?)Ⓔ/g);
                      if(textBoxs != null && textBoxs != undefined){
                        for(var j= 0;j<textBoxs.length;j++){
                          if(textBoxs[j] != null && textBoxs[j] != undefined){
                            var html = "";
                            var options = textBoxs[j].match(/Ⓣ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            if(options[1]!=null && options[1]!= undefined){
                              for(var l = 0;l<response.data.covenantAnswerList.length;l++){
                                if(response.data.covenantAnswerList[l].pageNum === i && response.data.covenantAnswerList[l].index === index){
                                   html = html + "<input type='text' name='textItem' disabled value='" + response.data.covenantAnswerList[l].value + "' style='width:" + options[1] + "px' id='textItem_" + index + "'/>";
                                  that.itemList[i].push({"id":"textItem_" + index,"index":index,"type":"textBox","label":options[0],"value":response.data.covenantAnswerList[l].value,"count":0});
                                }
                              }
                             
                            }
                            
                            
                            index++;
                            outerHtml = outerHtml.replace(
                            textBoxs[j],
                            html
                            );
                          }
                        }
                      }
                      // 文本描述题
                      let textAreas = outerHtml.match(/Ⓐ([\s\S]*?)Ⓔ/g);
                      if(textAreas != null && textAreas != undefined){
                        for(var j= 0;j<textAreas.length;j++){
                          if(textAreas[j] != null && textAreas[j] != undefined){
                            var html = "";
                            var options = textAreas[j].match(/Ⓐ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + options[0] + "　";
                            html = html + "<br><textarea  name='textAreaItem'";
                            if(options[1]!=null && options[1]!= undefined){
                              html = html + " rows='" + options[1] + "'";
                            }
                            if(options[2]!=null && options[2]!= undefined){
                              html = html + " cols='" + options[2] + "'";
                            }
                            for(var l = 0;l<response.data.covenantAnswerList.length;l++){
                              if(response.data.covenantAnswerList[l].pageNum === i && response.data.covenantAnswerList[l].index === index){
                                html = html + " id='textAreaItem_" + index + "' disabled>" + response.data.covenantAnswerList[l].value + "</textarea>";
                                that.itemList[i].push({"id":"textAreaItem_"+index,"index":index,"type":"textArea","label":options[0],"value":response.data.covenantAnswerList[l].value,"count":0});
                              }
                            }
                            
                            
                            index++;
                            outerHtml = outerHtml.replace(
                            textAreas[j],
                            html
                            );
                          }
                        }
                      }
                      // 等级题（星号）
                      let starts = outerHtml.match(/Ⓧ([\s\S]*?)Ⓔ/g);
                      if(starts != null && starts != undefined){
                        for(var j= 0;j<starts.length;j++){
                          if(starts[j] != null && starts[j] != undefined){
                            var html = "";
                            var options = starts[j].match(/Ⓧ([\s\S]*?)Ⓔ/)[1].split(",");
                            html = html + "<br>" + options[0] + "　";
                            var num = 0;
                            html = html + "<ul class='cleanfloat'>";
                            for(var l = 0;l<response.data.covenantAnswerList.length;l++){
                              if(response.data.covenantAnswerList[l].pageNum === i && response.data.covenantAnswerList[l].index === index){
                                num = response.data.covenantAnswerList[l].value;
                              }
                            }
                            for(var l = 1;l<6;l++){
                              if(l <= num) {
                                html = html + "<li name='star' class='hhs dis' style='list-style:none; float:left; font-size:15px; margin:5px;  cursor:pointer;' id='star_" + index + "_" + l + "'>★</li>";
                              } else {
                                html = html + "<li name='star' style='list-style:none; float:left; font-size:15px; margin:5px;  cursor:pointer;' class='dhs dis' id='star_" + index + "_" + l + "'>★</li>";
                              }
                              
                            }
                            html = html + "</ul><br>"
                            //html = html + "<ul class='cleanfloat'><li name='star' id='star_" + index + "_1'>★</li><li name='star' id='star_" + index + "_2'>★</li><li name='star' id='star_" + index + "_3'>★</li><li name='star' id='star_" + index + "_4'>★</li><li name='star' id='star_" + index + "_5'>★</li></ul>";
                            that.itemList[i].push({"id":"star_" + index,"index":index,"type":"star","label":options[0],"value":"","count":0});
                            index++;
                            outerHtml = outerHtml.replace(
                            starts[j],
                            html
                            );
                          }
                        }
                      }
                      covenantHtml = covenantHtml + outerHtml;
                    } 
                  }
                }
                that.covenantInfo.contentList[i] = covenantHtml;
              }
            }
          });
      },
      () => {
        //未登录跳回首页
        this.$router.push({
          path: "/home",
        });
      }
    );
  },
  methods: {
    getCount: function( str,findStr ) {
        let newStr = str.replace(new RegExp(findStr,"gm"),"");
        return str.length - newStr.length;
    },
    mouseOver: function(event){
      if(this.covenantInfo.flag == 0) {
        if(event.target.id.slice(0,4) == "star") {
          $(event.target).addClass('hs');
          $(event.target).prevAll().addClass('hs');
        }
      }
    },
    mouseout: function(event){
      if(this.covenantInfo.flag == 0) {
        if(event.target.id.slice(0,4) == "star") {
          $(event.target).removeClass('hs');
          $(event.target).prevAll().removeClass('hs');
        }
      }
    },
    checkClick: function(event) {
      if(this.covenantInfo.flag == 0) {
        if(event.target.id.slice(0,4) == "star") {
          $(event.target).addClass('cs');
          $(event.target).prevAll().addClass('cs');
          $(event.target).nextAll().removeClass('cs');
        }
      }
    },
    current_change: function (val) {
      // 获取当前页的输入值存入变量
      this.setValue();
      
      
      
      // 将变量中保存的控件值显示到页面
      this.currentPage = val;
      this.$nextTick(function(){
        for(var i=0;i<this.itemList[this.currentPage-1].length ;i++){
          if(this.itemList[this.currentPage-1][i]["type"] === "star"){
            for(var j=1;j<=this.itemList[this.currentPage-1][i]["value"];j++){
              var obj = window.document.getElementById(this.itemList[this.currentPage-1][i]["id"] + "_" + j);
              obj.className = "cs";
              
            }
          }
          // 文本框，多行文本
          if(this.itemList[this.currentPage-1][i]["type"] === "textBox" || this.itemList[this.currentPage-1][i]["type"] === "textArea"||this.itemList[this.currentPage-1][i]["type"] === "select"){
            var obj = window.document.getElementById(this.itemList[this.currentPage-1][i]["id"]);
            obj.value = this.itemList[this.currentPage-1][i]["value"];
          }
          // 多选
          if(this.itemList[this.currentPage-1][i]["type"] === "checkBox" || this.itemList[this.currentPage-1][i]["type"] === "radio"){
            var strValues = this.itemList[this.currentPage-1][i]["value"].split(",");
            for(var j =1;j<this.itemList[this.currentPage-1][i]["count"];j++){
              var obj = window.document.getElementById(this.itemList[this.currentPage-1][i]["id"] + "_" + j);
              for(var k = 0;k< strValues.length ; k++){
                if(obj.value === strValues[k]){
                  obj.checked = true;
                  break;
                }
              }
            }
          }
          // 单选
          if(this.itemList[this.currentPage-1][i]["type"] === "select"){
            for(var j =1;j<this.itemList[this.currentPage-1][i]["count"];j++){
              var all_options = document.getElementById(this.itemList[this.currentPage-1][i]["id"] + "_" + j).options;
              for (var k=0; k<all_options.length; k++){
                if (all_options[k].label == this.itemList[this.currentPage-1][i]["value"]) {
                  all_options[k].selected = true;
                }
              }
            }
          }
        }
      });
    },
    setValue: function() {
      // 获取当前页的输入值存入变量
      for(var i=0;i<this.itemList[this.currentPage-1].length ;i++){
        if(this.itemList[this.currentPage-1][i]["type"] === "star"){
          for(var j=1;j<6;j++){
            var obj = window.document.getElementById(this.itemList[this.currentPage-1][i]["id"] + "_" + j);
            if(obj.className != "cs"){
              break;
            }
            
          }
          this.itemList[this.currentPage-1][i]["value"] = j - 1;
        }
        // 文本框，多行文本
        if(this.itemList[this.currentPage-1][i]["type"] === "textBox" || this.itemList[this.currentPage-1][i]["type"] === "textArea"||this.itemList[this.currentPage-1][i]["type"] === "select"){
          var obj = window.document.getElementById(this.itemList[this.currentPage-1][i]["id"]);
          this.itemList[this.currentPage-1][i]["value"] = obj.value;
        }
        // 多选,单选
        if(this.itemList[this.currentPage-1][i]["type"] === "checkBox" || this.itemList[this.currentPage-1][i]["type"] === "radio"){
          var strValue = "";
          for(var j =1;j<this.itemList[this.currentPage-1][i]["count"];j++){
            var obj = window.document.getElementById(this.itemList[this.currentPage-1][i]["id"] + "_" + j);
            if(obj.checked){
              if(strValue === ""){
                strValue = obj.value;
              } else {
                strValue = strValue + "," + obj.value;
              }
              
            }
          }
          this.itemList[this.currentPage-1][i]["value"] = strValue;
        }
      }
    },
    goto_lesson: function () {
      console.log(this.$route.query.prev);
      if (this.$route.query.prev == null) {
        let outlineInfo = {
          courseId: this.$route.query.courseId,
          courseName: this.$route.query.courseName,
        };
        this.$router.push({
          path: "/home/schedule/schedule_curriculum",
          query: {
            outlineInfo: JSON.stringify(outlineInfo),
          },
        });
      } else {
        this.$router.push({
          name: '/home/schedule/schedule_aicourse',
          query: {
            buyCourseId: this.$route.query.courseId,
            buyCollegeId: JSON.stringify(1)
          }
        });
      }
    },
    //用户提交问卷调查题答案
    handleHintBox: function () {
      // 获取当前页的输入值存入变量
      this.setValue();
      // console.log(this.itemList);
      let checkFlag = true;
      // console.log(this.covenantInfo.checkBoxList[i]);
      for(var i = 0 ; i<this.covenantInfo.checkBoxList.length;i++) {
        if(this.covenantInfo.checkBoxList[i]) {
          if(!this.covenantInfo.agreeFlag[i]) {
            checkFlag = false;
            break;
          }
        }
      }
      
      if(!checkFlag) {
        this.$message.warning(window.vm.$i18n.t("js.uncheckMessage"));
        return;
      }
      this.$confirm(
        window.vm.$i18n.t("js.service"),
        window.vm.$i18n.t("js.hint"),
        {
          confirmButtonText: window.vm.$i18n.t("js.confirm"),
          cancelButtonText: window.vm.$i18n.t("js.cancel"),
          cancelButtonClass: "btn-custom-cancel"
        }
      )
        .then(() => {
          this.commit_answer();
        })
        .catch(() => {});
    },
    commit_answer: function () {
      let items = []
      for(var i =0;i<this.itemList.length;i++){
        for(var j = 0;j<this.itemList[i].length;j++){
          items.push({'pageNum':i,
          'index':this.itemList[i][j]['index'],
          'label':this.itemList[i][j]['label'],
          'value':this.itemList[i][j]['value'],
          'type':this.itemList[i][j]['type'],
          'count':this.itemList[i][j]['count'],
          })
        }
      }
      // console.log(items);
      this.$api
        .post("/studyCourseQuestion/commitScheduleCovenant", {
          covenantAnswerList:items,
          id: this.courseId,
          templateType: this.templateType
        })
        .then((response) => {
          // console.log(this.$route.query.prev);
          if (this.$route.query.prev == null) {
            let outlineInfo = {
              courseId: this.$route.query.courseId,
              courseName: this.$route.query.courseName,
            };
            this.$router.push({
              path: "/home/schedule/schedule_curriculum",
              query: {
                outlineInfo: JSON.stringify(outlineInfo),
              },
            });
          } else {
            if (this.categoryCourse==14||this.categoryCourse==15) {
              this.$api.post("/courseStudy/updateScheduleCourseFinished", {
                  courseId: this.courseId,
              })
              .then((response) => {});
            }
            this.$router.push({
              name: '/home/schedule/schedule_aicourse',
              query: {
                buyCourseId: this.$route.query.courseId,
                buyCollegeId: JSON.stringify(1)
              }
            });
          }
        });
    },
    agree: function () {
      if (this.covenantInfo.agreeFlag[this.currentPage - 1]) {
        this.covenantInfo.agreeFlag[this.currentPage - 1] = false;
        //this.agreeFlag = false;
      } else {
        this.covenantInfo.agreeFlag[this.currentPage - 1] = true;
        //this.agreeFlag = true;
      }
    },
  },
};
</script>

<style scoped="scoped">

@import "../../../static/css/exam.css";

.exam_begins_box {
  width: 60%;
  height: 100%;
  padding: 30px;
  border-radius: 15px;
  margin: 80px auto;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}

.examination_notes {
  height: 20px;
  font-size: 20px;
  color: #e8e6e6;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_box .exam_begins_rule {
  position: relative;
  /*display: -webkit-flex;*/
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px #414141 solid;
}

.exam_begins_rule .exam_begins_rule_title {
  width: auto;
  height: 20px;
  margin-right: 10px;
  font-size: 14px;
  color: #e8e6e6;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_rule .exam_begins_rule_content {
  padding-top: 20px;
  padding-left: 20px;
  max-width: 520px;
  min-height: 20px;
  position: relative;
  display: block;
}

.exam_begins_rule .exam_begins_rule_content p {
  min-height: 20px;
  line-height: 20px;
  display: flex;
  font-size: 14px;
  color: #e8e6e6;
  text-align: left;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}
.button_box {
  text-align: center;
}

.exam_btn {
  margin: 0 auto;
  margin-top: 40px;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  color: #e8e6e6;
  background-color: unset;
  padding: 4px 10px 6px 10px;
  border: 1px solid #e8e6e6;
  border-radius: 20px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}
.return {
  margin-top: 40px;
  margin-left: 60px;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  color: #e8e6e6;
  background-color: unset;
  padding: 4px 10px 6px 10px;
  border: 1px solid #e8e6e6;
  border-radius: 20px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}

.exam_btn:hover {
  color: #000;
  background-color: #fff;
  transition: 0.5s ease;
}
.return:hover {
  color: #000;
  background-color: #fff;
  transition: 0.5s ease;
}
.curriculum_page {
  width: 100%;
  background-image: url(../../../static/images/bg/personset_bg.jpg);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
}

.curriculum_main {
  background-color: rgba(65, 65, 65, 0.5);
  width: 100%;
  height: 100%;
  min-height: 600px;
  padding-bottom: 50px;
}

.curriculum_page_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: alac(100% - 19px);
  background-color: rgba(0, 0, 0, 0.3);
}

.curriculumPage {
  /*width: 1024px;*/
  margin: 0 auto;
  padding-top: 140px;
  position: relative;
}

.curriculumPage .page_title {
  height: 30px;
  line-height: 30px;
  font-size: 30px;
  color: #fafafa;
  /* font-family: lato-light, lato, sans-serif;
        font-weight: 400; */
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.curriculum_components {
  width: 680px;
  min-height: 200px;
  position: relative;
  margin-top: 40px;
  float: right;
  margin-left: 100px;
  right: 50px;
}
@media screen and (max-width: 1024px) {
  .curriculumPage {
    width: 94%;
    padding: 3%;
  }
  .exam_begins_box {
    width: 90%;
    padding: 30px 5%;
  }
}
</style>
<style lang="stylus" scoped>
  .cleanfloat::after{display: block; clear: both; content:""; visibility: hidden; height: 0;}/*清浮动*/
  ul li{list-style:none; float:left; font-size:15px; margin:5px; color:#ccc; cursor:pointer;}/*五角星样式*/

</style>
<style>
  .hs,.cs{color:red;}
  .hhs{color:red;}
  .dhs{color:#c7c7c2e5;}
  .dis{cursor:not-allowed;}
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    margin-top: 2px;
  }
  .select {
		display: inline-block;
		width: 100px;
		position: relative;
		vertical-align: middle;
		padding: 0;
		overflow: hidden;
		background-color: #fff;
		color: #555;
		border: 1px solid #aaa;
		text-shadow: none;
		border-radius: 4px;	
		transition: box-shadow 0.25s ease;
		z-index: 2;
	}
 
	.select:hover {
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
	}
 
	.select:before {
		content: "";
		position: absolute;
		width: 0;
		height: 0;
		border: 10px solid transparent;
		border-top-color: #ccc;
		top: 14px;
		right: 10px;
		cursor: pointer;
		z-index: -2;
	}
	.select select {
		cursor: pointer;
		padding: 10px;
		width: 100%;
		border: none;
		background: transparent;
		background-image: none;
		-webkit-appearance: none;
		-moz-appearance: none;
	}
 
	.select select:focus {
		outline: none;
	}

  
</style>


// WEBPACK FOOTER //
// src/views/schedule/scheduleCovenant.vue